import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Space } from '@redlink/components/atoms';
import { DataGridColumn } from './dataGridColumn';

export const DataGridTileColumn = memo(
  ({
    titleValueExtractor,
    subtitleValueExtractor,
    renderColumn,
    children,
    titleTextStyle,
    subtitleTextStyle,
    renderImage,
    ...rest
  }) => {
    const { styles } = useStyle();
    return (
      <DataGridColumn
        {...rest}
        renderColumn={(item) => {
          return (
            <View style={styles.container}>
              {renderImage?.(item)}
              <Space size={8} />
              <View style={styles.textsContainer}>
                <Text style={[styles.titleText, titleTextStyle]}>
                  {titleValueExtractor?.(item)}
                </Text>
                <Text style={[styles.subtitleText, subtitleTextStyle]}>
                  {subtitleValueExtractor?.(item)}
                </Text>
              </View>
            </View>
          );
        }}
      />
    );
  }
);

const useStyle = createUseStyle(({ colors, size }) => ({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  textsContainer: {},
  titleText: {
    fontSize: 14,
    color: colors.gray23,
  },
  subtitleText: {
    color: colors.gray23,
    fontSize: 12,
  },
}));
